export default __webpack_public_path__ + "static/media/Asset 1@10x-8.60a4a4fd.png";